var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophySvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.342,
    height: 12.599,
    viewBox: "0 0 11.342 12.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy-svgrepo-com",
    transform: "translate(-25.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6153",
    "data-name": "Path 6153",
    d: "M128.868,10.751V15.3a3.286,3.286,0,0,1-3.244,3.29h-.093a3.288,3.288,0,0,1-3.244-3.29V10.751Z",
    transform: "translate(-94.374 -10.486)",
    fill: "#f1c410"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6154",
    "data-name": "Path 6154",
    d: "M183.908,77.942l.52,1.2,1.3.125-.977.865.282,1.274-1.124-.662-1.124.662.282-1.274-.977-.865,1.3-.125Z",
    transform: "translate(-152.705 -76.024)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6155",
    "data-name": "Path 6155",
    d: "M203.615,317.4v1.482H200.9V317.4a3.273,3.273,0,0,0,1.309.291h.093A3.273,3.273,0,0,0,203.615,317.4Z",
    transform: "translate(-171.056 -309.59)",
    fill: "#e8594f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148108",
    "data-name": "Rectangle 148108",
    width: 1.323,
    height: 1.521,
    transform: "translate(30.542 9.292)",
    fill: "#f1c410"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6156",
    "data-name": "Path 6156",
    d: "M127.664,440.953h6.316l-.179-.821a.889.889,0,0,0-.868-.7h-4.222a.889.889,0,0,0-.868.7Z",
    transform: "translate(-99.619 -428.619)",
    fill: "#e8594f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162934",
    "data-name": "Group 162934",
    transform: "translate(25.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6157",
    "data-name": "Path 6157",
    d: "M172.29,69.735l-.248,1.121a.265.265,0,0,0,.392.285l.99-.583.99.583a.265.265,0,0,0,.392-.285l-.248-1.121.86-.761a.265.265,0,0,0-.15-.461l-1.143-.11-.458-1.053a.265.265,0,0,0-.485,0l-.458,1.053-1.143.11a.265.265,0,0,0-.15.461Zm.639-.821a.264.264,0,0,0,.217-.158l.278-.639.278.639a.264.264,0,0,0,.217.158l.693.067-.521.462a.264.264,0,0,0-.083.255l.151.68-.6-.353a.265.265,0,0,0-.268,0l-.6.353.151-.68a.265.265,0,0,0-.083-.255l-.521-.462Z",
    transform: "translate(-167.753 -65.537)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6158",
    "data-name": "Path 6158",
    d: "M36.61.992H34.758V.265A.265.265,0,0,0,34.493,0H27.913a.265.265,0,0,0-.265.265V.992H25.8a.265.265,0,0,0-.265.265V3.407A2.65,2.65,0,0,0,27.1,5.586a5.344,5.344,0,0,1,.9.757,3.569,3.569,0,0,0,1.587,1.633V9.292a.265.265,0,0,0,.265.265h.43v.992H29.092a1.16,1.16,0,0,0-1.127.908l-.179.821a.264.264,0,0,0,.258.321h6.316a.264.264,0,0,0,.258-.321l-.179-.821a1.16,1.16,0,0,0-1.127-.908H32.129V9.557h.43a.265.265,0,0,0,.265-.265V7.976a3.568,3.568,0,0,0,1.587-1.633,5.347,5.347,0,0,1,.9-.757,2.65,2.65,0,0,0,1.568-2.179V1.257A.265.265,0,0,0,36.61.992ZM27.364,5.128a2.16,2.16,0,0,1-1.3-1.72V1.521h1.587v3.29a3.6,3.6,0,0,0,.04.535s0,0,0,.005A2.774,2.774,0,0,0,27.364,5.128Zm6.561,6.442.109.5h-5.66l.109-.5a.628.628,0,0,1,.61-.492h4.222A.628.628,0,0,1,33.924,11.569ZM31.6,10.549h-.794V9.557H31.6Zm.694-1.521H30.112V8.2l.009,0a3.533,3.533,0,0,0,1.029.167h.107A3.535,3.535,0,0,0,32.276,8.2l.019-.006v.832Zm1.934-4.216a3.022,3.022,0,0,1-2.983,3.025H31.16q-.079,0-.157-.006a3.012,3.012,0,0,1-2.023-.967,3.013,3.013,0,0,1-.8-2.052V.529h6.051Zm2.116-1.4a2.161,2.161,0,0,1-1.3,1.72,2.764,2.764,0,0,0-.325.224s0,0,0,0a3.591,3.591,0,0,0,.04-.538V1.521h1.587V3.407Z",
    transform: "translate(-25.532)",
    fill: "#231f20"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophySvgrepoCom);
export default __webpack_public_path__ + "static/media/trophy-svgrepo-com.dfd09491118cb421e95e25925cdf0dd0.svg";
export { ForwardRef as ReactComponent };